export default __webpack_public_path__ + "static/media/newLook.07e4cc7d.jpeg";